module.exports = __webpack_public_path__ + "img/5.bcc20894.png";